import { getIframeLayout, LAYOUTS } from './queryParams';

// This is used by the CMS to handle page actions post checkout submission
export const sendPostMessage = (event, sourceId) => {
  const iFrameLayout = getIframeLayout();
  if (iFrameLayout === LAYOUTS.FULL_PAGE_OVERLAY) {
    window.parent.postMessage({
      event,
      data: {
        paymentLinkId: sourceId
      }
    }, '*');
  } else if (window.parent !== window) {
    // nosemgrep: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
    // Payload contains no sensitive data ({ type: 'SUCCESS' } only). The
    // billing portal validates event.origin against the expected quote page
    // origin on receipt. The existing FULL_PAGE_OVERLAY branch also uses '*'.
    window.parent.postMessage({
      type: event
    }, '*');
  }
};